const getAjaxUrl = () => {
  return window.ajaxUrl;
};

export default getAjaxUrl();